var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_vm._v("新闻中心")])
}
var staticRenderFns = []

export { render, staticRenderFns }